import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a591d765dd08a0014a6fbab_1784281111412_d6ae22b8/spectrasmc/src/app/login-screen/components/LoginClient.tsx");
